const messages = {
    en: {
        firstAnswer: "First incorrect answer",
        secondAnswer: "Second incorrect answer",
        thirdAnswer: "Third incorrect answer",
        fourthAnswer: "Fourth correct answer",
        question: "Your question",
        sendQuestion: "Send question",
        approveAndsaveQuestion: "Approve and save question", 
        saveQuestionAndReturnToQuestionsList: "Save question and return",
        saveAndMoveToNextQuestions: "Save question and move to the next",
        clearValues: "Clear Values",
        declineQuestion: "Decline question",
        backToContributionPage: "Back to previous page",
        save: "Save",
        reset: "Reset",
        saveAndGoToTheNextQuestion: "Save and load next Question >>",
        saveAndGoToThePrevQuestion: "Save and load previous Question",
        deleteAndReturn: "Delete this question and return",
        sendFeedback: "Send feedback",
        deleteAndLoadNext: "Delete this question and load next >>",
        seeMyContributionStatus: "Status of my questions",
        limit: "Limit",
    },
    ru: {
        firstAnswer: "Первый неправильный ответ",
        secondAnswer: "Bторой неправильный ответ",
        thirdAnswer: "Tретий неправильный ответ",
        fourthAnswer: "Четвертый правильный ответ",
        question: "Ваш вопрос",
        sendQuestion: "Отправить вопрос",
        approveAndsaveQuestion: "Approve and save question",
        saveQuestion: "Save question",
        saveQuestionAndReturnToQuestionsList: "Save question and return",
        saveAndMoveToNextQuestions: "Save question and move to the next",
        clearValues: "Очистить значения",
        backToContributionPage: "Вернуться на предыдущую страницу",
        save: "Сохранить",
        reset: "Oчистить",
        saveAndGoToTheNextQuestion: "Save and load next Question >>",
        saveAndGoToThePrevQuestion: "Save and load previous Question",
        deleteAndReturn: "Delete this question and return",
        sendFeedback: "Отправить отзыв",
        deleteAndLoadNext: "Delete this question and load next >>",
        seeMyContributionStatus: "Cтатус моих вопросов",
        limit: "Лимит",
     }
  };

  export default messages;